import script from "./order.vue?vue&type=script&setup=true&lang=js"
export * from "./order.vue?vue&type=script&setup=true&lang=js"

import "./order.vue?vue&type=style&index=0&id=0845a8ae&scoped=true&lang=css"

import exportComponent from "/Users/huangzexu/Code/Vue/Yiban/yiban/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0845a8ae"]])

export default __exports__